export class Documento {
  constructor({ uuid, observacao, data_criacao, url, usuario }) {
    this.uuid = uuid;
    this.observacao = observacao;
    this.data_criacao = data_criacao;
    this.url = url;
    this.usuario = usuario;
  }
}
